import { connect } from 'react-redux';

import CancelPopUp from '../../components/AccountSettings/ManageSubscription/CancelPopUp/CancelPopUpView';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => ({});

const CancelPopUpContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CancelPopUp);

export default CancelPopUpContainer;
